import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // Импортируйте useParams
import Article from '../components/Blog/Article';
import { BACKEND_URL } from '../consts';

const Art = () => {
  const { id } = useParams(); // Получаем ID из параметров маршрута
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const navigate = useNavigate(); // Инициализируем navigate
  // const BASE_URL =`http://v2691254.hosted-by-vdsina.ru/api/v1/block/blog/${id}`; // Используем ID в URL
  const BASE_URL = `${BACKEND_URL}/api/v1/block/blog/${id}`; // Используем ID в URL

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(BASE_URL);
        if (!response.ok) {
          navigate('/404'); // Перенаправление на страницу 404
          return; // Выход из функции, чтобы не продолжать выполнение
        }
        const fetchData = await response.json();
        setData(fetchData);
        console.log(fetchData);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [BASE_URL]); // Добавьте BASE_URL в зависимости

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <Article data={data} />
    </>
  );
};

export default Art;
